import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ErrorModal, SuccessModal } from "@components";
import {
  UpdateLeaveBalanceBody,
  UpdateLeaveBalancePageHeader,
} from "./components";

import { useLeaveSummary } from "@hooks/HRM/leave/useLeaveSummary";

import { ROUTES } from "@constants/routes";
import { TABS } from "@constants/tab-serial";

const {
  HRM: { EMPLOYEES },
} = ROUTES;

const UpdateLeaveBalance = () => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const { id } = useParams();
  const navigate = useNavigate();

  const { leaveBalance } = useLeaveSummary(id as string);

  // error and success modal
  const closeErrorModal = () => {
    setMessage("");
    setIsErrorModalOpen(false);
  };
  const successAction = () => navigate(`${EMPLOYEES}/${id}?tab=${TABS.LEAVE}`);

  useEffect(() => {
    const reset = () => {
      setIsErrorModalOpen(false);
      setIsSuccessModalOpen(false);
      setMessage("");
    };
    return reset();
  }, []);

  return (
    <div className="p-10">
      {/* MODAL SECTION */}
      <>
        <SuccessModal isModalOpen={isSuccessModalOpen} action={successAction} />
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
          subtitle={message}
        />
      </>
      {/* MODAL SECTION */}
      <UpdateLeaveBalancePageHeader employeeID={id as string} />
      <UpdateLeaveBalanceBody
        employeeID={id as string}
        leaveBalance={leaveBalance}
        successAction={successAction}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
        setIsErrorModalOpen={setIsErrorModalOpen}
        setMessage={setMessage}
      />
    </div>
  );
};

export default UpdateLeaveBalance;
